<template>
<div class="page-wrapper">
	<div class="page page-members" v-if="user">
		<div class="container">
			<div class="page-header">
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-6 p-0">
							<h1 class="page-title">Team Members</h1>
							<div v-if="user.credit && user.credit.team_member > 0">You can add {{user.credit.team_member}} more team member<span v-if="user.credit.team_member > 1">s</span></div>
						</div>
						<div class="col-md-6 p-0">
							<div class="details-actions">
								<!-- <router-link
									class="btn btn-light mr-2 px-3"
									to="/rotators">
									Member Rotators
								</router-link>
								<router-link
									class="btn btn-light mr-2"
									to="/reports/team">
									View Team Performances
								</router-link> -->
								<router-link
									class="btn btn-primary"
									to="/members/new"
									v-if="user && user.credit && user.credit.team_member !== 0 && (isOwner || isCanAdd)">
									<i class="material-icons">add</i>
									<span>Add New Member</span>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page-content">
				<members-table></members-table>
			</div>
		</div>
	</div>
	<div class="page" v-if="!user">
		<div class="is-loading large"></div>
	</div>

<notifications group="members" position="bottom right" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MembersTable from '../components/MembersTable.vue';

export default {
	name: 'members',
	components: {
		MembersTable,
	},
	data() {
		return {
		};
	},
	methods: {
		...mapActions({
		}),
		checkCapabilities() {
			if (!this.isOwner && !this.isUserCan('team_member_view')) {
				this.$router.push('/');
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
		}),
		isOwner() {
			return this.user && this.user.role === 'owner';
		},
		isCanAdd() {
			return this.user && this.isUserCan('team_member_add');
		},
		isCanEdit() {
			return this.user && this.isUserCan('team_member_edit');
		},
		isCanDelete() {
			return this.user && this.isUserCan('team_member_delete');
		},
	},
	created() {
		if (this.user) {
			this.checkCapabilities();
		}
	},
	watch: {
		user() {
			this.checkCapabilities();
		},
	},
};
</script>
